import {
  STREAMLAIN_COMPACT_HEADER_AREA_STYLE,
  STREAMLAIN_COMPACT_HEADER_PADDING,
  STREAMLAIN_HEADER_BORDER_WIDTH,
} from '@blocksuite/affine-shared/styles';
import { css } from '@emotion/css';
import { cssVarV2 } from '@streamlain/theme/v2';

export const databaseBlockStyles = css({
  display: 'block',
  '--database-view-sticky-top': '0px',
  borderRadius: '8px',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  padding: '8px',
  margin: '8px -8px -8px',
  '&[data-streamlain-database-surface="fullscreen"]': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  '&[data-streamlain-database-surface="fullscreen"] > div[contenteditable="false"]':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] > .affine-block-component':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] > .affine-block-component > div':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer .data-view-root':
    {
      display: 'flex !important',
      flexDirection: 'column',
      flex: '1 1 0',
      height: 'auto',
      minHeight: 0,
      maxHeight: 'none',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer .data-view-root [data-data-view-frame-top="true"], &[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer .data-view-root [data-data-view-frame-footer="true"]':
    {
      flex: '0 0 auto',
      minHeight: 0,
    },
  '&[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer .data-view-root [data-data-view-frame-body="true"]':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0',
      height: 'auto',
      minHeight: 0,
      maxHeight: 'none',
      overflow: 'hidden',
    },
  '&[data-streamlain-database-surface="fullscreen"] affine-data-view-renderer .data-view-root [data-data-view-frame-body="true"] > *':
    {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0',
      height: 'auto',
      minHeight: 0,
      overflow: 'hidden',
    },
});

export const databaseBlockSelectedStyles = css({
  backgroundColor: 'var(--streamlain-hover-color)',
  borderRadius: '4px',
});

export const databaseOpsStyles = css({
  boxSizing: 'border-box',
  width: '32px',
  height: '32px',
  padding: '6px',
  border: 0,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  fontSize: '20px',
  color: cssVarV2.icon.primary,
  transition: 'background-color 120ms ease, color 120ms ease',
  ':hover': {
    backgroundColor: 'var(--streamlain-hover-color)',
  },

  '@media print': {
    display: 'none',
  },
});

export const databaseHeaderBarStyles = css({
  '@media print': {
    display: 'none !important',
  },
});

export const databaseTitleStyles = css({
  flex: '1 1 0',
  minWidth: 0,
  overflow: 'hidden',
});

export const databaseHeaderContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  '&[data-database-surface="canvas"] > [data-database-header-area="true"]': {
    borderBottom: 0,
  },
  '&[data-database-surface="fullscreen"] > [data-database-header-area="true"]':
    {
      paddingInlineEnd: 'var(--streamlain-fullscreen-close-inline-inset, 48px)',
    },
});

export const databaseHeaderAreaStyles = css({
  ...STREAMLAIN_COMPACT_HEADER_AREA_STYLE,
  padding: STREAMLAIN_COMPACT_HEADER_PADDING,
  borderBottom: `${STREAMLAIN_HEADER_BORDER_WIDTH} solid var(--streamlain-border-color)`,
});

export const databaseHeaderStickyStyles = css({
  position: 'sticky',
  top: 0,
  zIndex: 30,
  backgroundColor: 'var(--streamlain-background-primary-color)',
});

export const databaseTitleRowStyles = css({
  display: 'flex',
  flex: '1 1 0',
  minWidth: 0,
  overflow: 'hidden',
  gap: '8px',
  alignItems: 'center',
  pointerEvents: 'none',
  '& > *': {
    pointerEvents: 'auto',
  },
});

export const databaseChromePrimaryRowStyles = css({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  height: '100%',
  minHeight: 0,
  minWidth: 0,
  boxSizing: 'border-box',
});

export const databaseHeaderActionsStyles = css({
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 auto',
  justifyContent: 'flex-end',
  gap: '8px',
  minWidth: 0,
  position: 'relative',
  zIndex: 2,
  '&[data-database-header-actions-surface="canvas"]': {
    contain: 'layout paint',
    isolation: 'isolate',
    overflow: 'clip',
    position: 'static',
    zIndex: 'auto',
  },
});

export const databaseToolbarRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '6px',
  minWidth: 0,
});

export const databaseTrailingActionsStyles = css({
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 auto',
  gap: '2px',
});

export const databaseInlineLargeDataBoundaryStyles = css({
  alignSelf: 'flex-start',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '6px',
  color: 'var(--streamlain-text-secondary-color)',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12px',
  lineHeight: '18px',
  padding: '2px 8px',
  backgroundColor: 'var(--streamlain-background-secondary-color)',
  button: {
    border: 'none',
    borderRadius: '4px',
    color: 'var(--streamlain-text-primary-color)',
    backgroundColor: 'var(--streamlain-hover-color)',
    cursor: 'pointer',
    font: 'inherit',
    lineHeight: '18px',
    padding: '0 6px',
  },
  'button:hover': {
    backgroundColor: 'var(--streamlain-black-10)',
  },
});

export const databaseInlineLargeDataPreviewStyles = css({
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '8px',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minHeight: '96px',
  padding: '16px',
  '.database-inline-large-data-preview-title': {
    color: 'var(--streamlain-text-primary-color)',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.database-inline-large-data-preview-message': {
    color: 'var(--streamlain-text-secondary-color)',
    fontSize: '13px',
    lineHeight: '20px',
  },
});

const databaseWindowControlsButtonStyles = {
  border: 'none',
  borderRadius: '999px',
  boxSizing: 'border-box',
  color: 'var(--streamlain-text-primary-color)',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  font: 'inherit',
  height: '26px',
  lineHeight: '18px',
  minWidth: '26px',
  padding: '0 6px',
  transition: 'background-color 120ms ease, color 120ms ease',
} as const;

const databaseWindowControlsButtonStateStyles = {
  'button:hover:not(:disabled)': {
    backgroundColor: 'var(--streamlain-hover-color)',
  },
  'button:disabled': {
    cursor: 'not-allowed',
    color: 'var(--streamlain-text-secondary-color)',
    opacity: 0.4,
  },
} as const;

export const databaseRowWindowFooterStyles = css({
  alignSelf: 'stretch',
  border: 0,
  borderTop: '1px solid var(--streamlain-border-color)',
  borderRadius: 0,
  color: 'var(--streamlain-text-secondary-color)',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  gap: '10px',
  fontSize: '12px',
  lineHeight: '18px',
  margin: '0',
  minHeight: '38px',
  padding: '0 14px',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  boxShadow: 'none',
  width: '100%',
  '.database-window-section': {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
    alignItems: 'center',
    flex: '1 1 auto',
    minWidth: 0,
    width: '100%',
    maxWidth: '1080px',
    margin: '0 auto',
    gap: '12px',
  },
  '.database-window-summary': {
    alignItems: 'center',
    display: 'inline-flex',
    gap: '8px',
    justifySelf: 'start',
    minWidth: 0,
  },
  '.database-window-center': {
    alignItems: 'center',
    display: 'inline-flex',
    justifySelf: 'center',
    minWidth: 0,
    overflow: 'visible',
  },
  '.database-window-actions': {
    alignItems: 'center',
    display: 'inline-flex',
    justifySelf: 'end',
    minWidth: 0,
  },
  '.database-window-status': {
    color: 'var(--streamlain-text-primary-color)',
    fontWeight: 500,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.database-window-meta': {
    alignItems: 'center',
    color: 'var(--streamlain-text-secondary-color)',
    backgroundColor: 'var(--streamlain-background-secondary-color)',
    borderRadius: '999px',
    display: 'inline-flex',
    fontSize: '11px',
    lineHeight: '16px',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
  },
  '.database-window-control-pill': {
    alignItems: 'center',
    backgroundColor: 'var(--streamlain-background-secondary-color)',
    border: '1px solid var(--streamlain-border-color)',
    borderRadius: '999px',
    boxSizing: 'border-box',
    display: 'grid',
    height: '32px',
    justifyItems: 'center',
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'relative',
    transition:
      'width 180ms cubic-bezier(0.22, 1, 0.36, 1), background-color 120ms ease, border-color 120ms ease',
    width: 'var(--database-window-control-pill-width, 230px)',
    willChange: 'width',
  },
  '.database-window-control-layer, .database-window-selection-layer': {
    alignItems: 'center',
    display: 'inline-flex',
    gridArea: '1 / 1',
    justifyContent: 'center',
    minWidth: 0,
    transition:
      'opacity 160ms ease, transform 180ms cubic-bezier(0.22, 1, 0.36, 1)',
    willChange: 'opacity, transform',
  },
  '.database-window-selection-layer': {
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translateY(18px) scale(0.96)',
  },
  '.database-window-control-pill[data-selection-active="true"] .database-window-control-layer':
    {
      opacity: 0,
      pointerEvents: 'none',
      transform: 'translateY(-18px) scale(0.96)',
    },
  '.database-window-control-pill[data-selection-active="true"] .database-window-selection-layer':
    {
      opacity: 1,
      pointerEvents: 'auto',
      transform: 'translateY(0) scale(1)',
    },
  '.database-window-nav': {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    borderRadius: '999px',
    boxSizing: 'border-box',
    display: 'inline-flex',
    gap: '2px',
    height: '28px',
    padding: '2px',
    transition: 'opacity 120ms ease',
    whiteSpace: 'nowrap',
  },
  '.database-window-nav[data-inactive="true"]': {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    opacity: 1,
  },
  '.database-window-nav[data-inactive="true"] .database-window-icon-button': {
    opacity: 0.45,
  },
  '.database-window-limit, .database-window-page': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    height: '26px',
    whiteSpace: 'nowrap',
  },
  '.database-window-limit': {
    transition: 'opacity 120ms ease',
  },
  '.database-window-limit[data-inactive="true"]': {
    opacity: 0.5,
  },
  '.database-window-icon-button': {
    padding: 0,
    width: '26px',
  },
  '.database-window-icon-button svg': {
    display: 'block',
  },
  button: databaseWindowControlsButtonStyles,
  'input, .database-window-limit-button': {
    border: '1px solid var(--streamlain-border-color)',
    borderRadius: '6px',
    boxSizing: 'border-box',
    color: 'var(--streamlain-text-primary-color)',
    font: 'inherit',
    fontVariantNumeric: 'tabular-nums',
    height: '24px',
    lineHeight: '16px',
    margin: 0,
    padding: '0 6px',
    transition: 'background-color 120ms ease, border-color 120ms ease',
  },
  'input:disabled, .database-window-limit-button:disabled': {
    backgroundColor: 'var(--streamlain-background-secondary-color)',
    color: 'var(--streamlain-text-secondary-color)',
    opacity: 1,
  },
  input: {
    backgroundColor: 'var(--streamlain-background-secondary-color)',
    textAlign: 'center',
    width: '34px',
    padding: '0 2px',
  },
  'input:hover:not(:disabled)': {
    borderColor: 'var(--streamlain-border-color)',
  },
  '.database-window-limit-button': {
    alignItems: 'center',
    backgroundColor: 'var(--streamlain-background-secondary-color)',
    cursor: 'pointer',
    display: 'inline-flex',
    gap: '4px',
    justifyContent: 'center',
    minWidth: '82px',
    padding: '0 10px',
    whiteSpace: 'nowrap',
  },
  '.database-window-limit-button:hover:not(:disabled)': {
    backgroundColor: 'var(--streamlain-hover-color)',
    borderColor: 'var(--streamlain-border-color)',
  },
  '.database-window-page-combobox': {
    alignItems: 'center',
    display: 'inline-flex',
    gap: 0,
  },
  '.database-window-selection-toolbar': {
    alignItems: 'center',
    display: 'inline-flex',
    gap: '4px',
    height: '28px',
    justifyContent: 'center',
    minWidth: 0,
    padding: '0 4px',
  },
  '.database-window-selection-count': {
    alignItems: 'center',
    color: 'var(--streamlain-text-secondary-color)',
    display: 'inline-flex',
    fontSize: '12px',
    fontWeight: 500,
    height: '24px',
    lineHeight: '18px',
    padding: '0 4px',
    whiteSpace: 'nowrap',
  },
  '.database-window-selection-separator': {
    backgroundColor: 'var(--streamlain-border-color)',
    display: 'inline-block',
    height: '20px',
    width: '1px',
  },
  '.database-window-selection-button': {
    color: 'var(--streamlain-text-secondary-color)',
    borderRadius: '8px',
    height: '24px',
    minWidth: '24px',
    padding: 0,
    width: '24px',
  },
  '.database-window-selection-button-danger': {
    color: 'var(--streamlain-error-color)',
  },
  '.database-window-selection-button-danger:hover:not(:disabled)': {
    backgroundColor: 'var(--streamlain-background-error-color)',
    color: 'var(--streamlain-error-color)',
  },
  '@media (max-width: 720px)': {
    padding: '0 10px',
    gap: '8px',
    '.database-window-section': {
      gap: '8px',
    },
    '.database-window-summary, .database-window-actions': {
      overflow: 'hidden',
    },
    '.database-window-meta': {
      display: 'none',
    },
    '.database-window-control-pill': {
      width: 'min(var(--database-window-control-pill-width, 230px), 100%)',
    },
  },
  ...databaseWindowControlsButtonStateStyles,
});

export const databaseRowWindowPageMenuPortalStyles = css({
  backgroundColor: 'var(--streamlain-background-primary-color)',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '10px',
  boxShadow: 'var(--affine-shadow-2)',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  left: 0,
  maxHeight: '176px',
  minWidth: '84px',
  overflowY: 'auto',
  padding: '4px',
  position: 'fixed',
  top: 0,
  zIndex: 1000,
  '.database-window-page-option': {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: '6px',
    color: 'var(--streamlain-text-primary-color)',
    cursor: 'pointer',
    display: 'flex',
    flex: '0 0 30px',
    font: 'inherit',
    fontVariantNumeric: 'tabular-nums',
    justifyContent: 'center',
    minHeight: '30px',
    padding: '0 8px',
  },
  '.database-window-page-option:hover': {
    backgroundColor: 'var(--streamlain-hover-color)',
  },
  '.database-window-page-option[data-selected="true"]': {
    backgroundColor: 'var(--streamlain-primary-color)',
    color: 'var(--streamlain-pure-white)',
    fontWeight: 600,
  },
});

export const databaseStickyRowWindowFooterStyles = css({
  position: 'sticky',
  bottom: 0,
  zIndex: 20,
  boxShadow: '0 -1px 0 0 var(--streamlain-border-color)',
});

export const databaseCanvasRowWindowFooterStyles = css({
  position: 'static',
  bottom: 'auto',
  backgroundColor: 'var(--streamlain-background-secondary-color)',
  border: '1px solid var(--streamlain-border-color)',
  borderBottom: 0,
  borderRadius: '8px 8px 0 0',
  boxShadow: 'none',
  flex: '0 0 auto',
  margin: 0,
  minHeight: '42px',
  overflow: 'hidden',
  padding: '4px 10px',
  zIndex: 'auto',
  '.database-window-section': {
    maxWidth: 'none',
  },
  '.database-window-control-pill': {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    height: '32px',
  },
  '.database-window-control-pill[data-selection-active="true"]': {
    backgroundColor: 'var(--streamlain-background-primary-color)',
    borderColor: 'var(--streamlain-border-color)',
  },
});

export const databaseFullscreenRowWindowFooterStyles = css({
  position: 'static',
  flex: '0 0 auto',
  margin: 0,
  boxShadow: '0 -1px 0 0 var(--streamlain-border-color)',
});

export const databaseViewBarContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  flex: '0 1 auto',
  minWidth: '84px',
  maxWidth: '280px',
  overflow: 'hidden',
  '> uni-lit': {
    display: 'flex',
    height: '28px',
    minWidth: 0,
  },
  '&[data-separated="true"]': {
    marginRight: '4px',
    paddingRight: '12px',
  },
});

export const databaseContentStyles = css({
  position: 'relative',
  backgroundColor: 'var(--streamlain-background-primary-color)',
  borderRadius: '4px',
});

export const databaseShardErrorStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '12px',
  border: '1px solid var(--streamlain-error-color)',
  borderRadius: '8px',
  backgroundColor: 'var(--streamlain-background-error-color)',
  color: 'var(--streamlain-text-primary-color)',
  '& .database-shard-error-title': {
    color: 'var(--streamlain-error-color)',
    fontWeight: 600,
  },
  '& .database-shard-error-message': {
    color: 'var(--streamlain-text-secondary-color)',
    fontSize: '13px',
    lineHeight: 1.4,
  },
  '& .database-shard-error-consequence': {
    color: 'var(--streamlain-text-secondary-color)',
    fontSize: '12px',
    lineHeight: 1.4,
  },
  '& .database-shard-error-action': {
    alignSelf: 'flex-start',
    minHeight: '30px',
    padding: '4px 10px',
    border: '1px solid var(--streamlain-border-color)',
    borderRadius: '6px',
    backgroundColor: 'var(--streamlain-background-primary-color)',
    color: 'var(--streamlain-text-primary-color)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'var(--streamlain-hover-color)',
    },
    '&:focus-visible': {
      outline: '2px solid var(--streamlain-primary-color)',
      outlineOffset: '2px',
    },
  },
});

// Streamlain: Fullscreen button style (for edgeless canvas databases)
export const databaseFullscreenButtonStyles = css({
  boxSizing: 'border-box',
  width: '32px',
  height: '32px',
  padding: '6px',
  border: 0,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  fontSize: '20px',
  color: cssVarV2.icon.primary,
  transition: 'background-color 120ms ease, color 120ms ease',
  ':hover': {
    backgroundColor: 'var(--streamlain-hover-color)',
  },

  '@media print': {
    display: 'none',
  },
});
